var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleciLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7504 20.6171C14.7504 17.9954 16.9157 15.844 19.5545 15.844C22.1934 15.844 24.3586 17.9954 24.3586 20.6171C24.3586 23.239 22.1934 25.3902 19.5545 25.3902C16.8479 25.3902 14.7504 23.3063 14.7504 20.6171ZM19.5545 0.650757C10.1494 0.650757 2.23286 7.03732 0 15.7096V15.9113C0 16.449 0.405976 16.8524 0.947277 16.8524H9.06679C9.47277 16.8524 9.81108 16.6507 9.94641 16.3146C11.638 12.6844 15.2918 10.197 19.5545 10.197C25.3735 10.197 30.1099 14.9029 30.1099 20.6844C30.1099 26.4659 25.3735 31.1718 19.5545 31.1718C15.2918 31.1718 11.638 28.6844 9.94641 25.0541C9.81108 24.718 9.47277 24.5164 9.06679 24.5164H0.947277C0.405976 24.4491 0 24.8524 0 25.3902V25.5919C2.23286 34.2641 10.1494 40.6508 19.5545 40.6508C30.6512 40.6508 39.6504 31.7095 39.6504 20.6844C39.6504 9.59194 30.6512 0.650757 19.5545 0.650757Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleciLogo);
export default __webpack_public_path__ + "static/media/circleci-logo.01d4d6dbcbb67f87b52b0ec78395ccb2.svg";
export { ForwardRef as ReactComponent };